import { render } from "./sla_workflows.html?vue&type=template&id=c2af7bf4&external"
import script from "./sla_workflows.js?vue&type=script&lang=js&external"
export * from "./sla_workflows.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__